export enum StoragePages {
	StorageScanner = '/tabs/storage/assign',
	StorageDetail = '/tabs/storage/:storageId/detail',
	PallyDetail = '/tabs/storage/pally/:pallyId/detail',
}
